export class SaveHostLanguagesModel {
    languages: string[];
    constructor(languages: string[]) {
        this.languages = languages;
    }
}